import { updateTicketExpiration } from './update-ticket-expiration';

let updateSessionExpirationOnAllAjaxCompletesLoaded = false;

/**
 * Inspects a jQuery XHR object and updates the local session expiration
 * based on the server's response
 * @param jqXHR A jQuery jqXHR
 */
export function updateSessionExpiration (jqXHR: JQuery.jqXHR): void {
	const sessionExpiry = jqXHR.getResponseHeader('x-session-expiry');

	if (sessionExpiry != null) {
		updateTicketExpiration(sessionExpiry);
	}
}

/**
 * Registers a handler to all jQuery AJAX responses which will update
 * the local session expiration based on the server's response
 */
export function updateSessionExpirationOnAllAjaxCompletes (): void {
	if (!updateSessionExpirationOnAllAjaxCompletesLoaded) {
		$(document).ajaxComplete(function (_, jqXHR) {
			updateSessionExpiration(jqXHR);
		});

		updateSessionExpirationOnAllAjaxCompletesLoaded = true;
	}
}
